import "isomorphic-fetch";
import settings from "../../settings.json";

let v4_data = null;
let v6_data = null;
const v4_cbs = [];
const v6_cbs = [];

function doAll(data, cbs, cb_name) {
    for (const c of cbs) {
        c[cb_name](data);
    }
}

fetch(settings.urls.ipv4)
    .then(response => response.json())
    .then(response => doAll(v4_data = response, v4_cbs, "resolve"))
    .catch(() => doAll(v4_data = false, v4_cbs, "reject"));
fetch(settings.urls.ipv6)
    .then(response => response.json())
    .then(response => doAll(v6_data = response, v6_cbs, "resolve"))
    .catch(() => doAll(v6_data = false, v6_cbs, "reject"));

function getData(data, cbs) {
    return new Promise((resolve, reject) => {
        if (data === false) {
            reject(data);
        } else if (data) {
            resolve(data);
        } else {
            cbs.push({ resolve, reject });
        }
    });
}

export function getV4Data() {
    return getData(v4_data, v4_cbs);
}

export function getV6Data() {
    return getData(v6_data, v6_cbs);
}



// WEBPACK FOOTER //
// ./frontend/utils/ip.js